module.exports = __webpack_public_path__ + "img/bt-2.1abac6c0.png";